import { useChatInstancesStore } from '../../../store/chatInstancesStore';
import { useOptionalTargetId } from '../../../store/projectStore';

export function useCoPilotSessionExportTargetId({
  threadId,
  targetId,
}: {
  threadId?: string;
  targetId?: string;
}): string | undefined {
  const configTargetId = useChatInstancesStore((state) => {
    if (!threadId) {
      return undefined;
    }

    const config = state.configs.get(threadId);
    return config?.applicationId ?? config?.surfaceId;
  });
  const projectTargetId = useOptionalTargetId();

  return targetId ?? configTargetId ?? projectTargetId;
}
